







import { defineComponent } from '@vue/composition-api'
import CopyButtonAction from '@/components/common/actions/CopyButtonAction.vue'
import type { Media } from '@futureecom/futureecom-js/dist/services/cms-service'
import type { PropType } from '@vue/composition-api'

export default defineComponent({
  name: 'MediaActionCopyLink',

  components: { CopyButtonAction },

  props: {
    value: {
      type: Object as PropType<Media>,
      required: true
    }
  }
})
